import { Box, CircularProgress, useTheme } from "@mui/material";
import { BrightBotSmileIcon } from "../../../../../common/Icons/BrightBotSmileIcon";
import { ChatRcvBotDescription, ChatRcvBotWidgetWrapper } from "./style";
import { AvatarWrapper } from "../../style";
import LightbulbIcon from "@mui/icons-material/Lightbulb";
import { useState } from "react";
import { useSessionStore } from "../../../../../store/useSessionStore";

type Props = {
  avatar?: string;
  children: React.ReactNode;
  streaming?: boolean;
  reasoningComp?: React.ReactNode;
  msgReasoningEnabled?: boolean;
};

export const ChatRcvBotWidget = ({
  avatar,
  children,
  streaming,
  reasoningComp,
  msgReasoningEnabled = false, // for the specific message
}: Props) => {
  const { palette } = useTheme();
  const [displayReasoning, setDisplayReasoning] = useState(false);
  const streamReasoningEnabled = useSessionStore.use.reasoningEnabled();

  // Toggle display of reasoning when the reasoning icon is clicked
  // Only toggle if streaming isn't true
  const handleDisplayReasoning = () => {
    if (!streaming) setDisplayReasoning((prev) => !prev);
  };

  return (
    <ChatRcvBotWidgetWrapper
      sx={{ position: "relative" }}
      className="ChatRcvBotWidget"
    >
      {streaming && (
        <CircularProgress
          size={38} // Adjust size
          thickness={4} // Adjust thickness
          sx={{
            position: "absolute",
            top: "-3px",
            left: "-3px",
          }}
        />
      )}
      <Box display="flex" flexDirection="column" alignItems="center">
        <AvatarWrapper>
          {avatar && <img src={avatar} alt="" />}
          <BrightBotSmileIcon />
        </AvatarWrapper>
        {(msgReasoningEnabled || (streaming && streamReasoningEnabled)) && (
          <AvatarWrapper
            onClick={handleDisplayReasoning}
            sx={{
              cursor: streaming ? "" : "pointer", // Disable pointer events when streaming
              marginTop: ".5rem",
              width: "28px",
              height: "28px",
              background: displayReasoning ? palette.primary.main : "",
            }}
          >
            {streaming && (
              <CircularProgress
                size={32} // Adjust size
                thickness={4} // Adjust thickness
                sx={{
                  color: streaming ? "darkgreen" : "",
                  position: "absolute",
                  top: "-2px",
                  left: "-3px",
                }}
              />
            )}
            {avatar && <img src={avatar} alt="" />}
            <LightbulbIcon
              style={{
                color: displayReasoning
                  ? palette.common.white
                  : palette.gray.dark,
              }}
            />
          </AvatarWrapper>
        )}
      </Box>
      <Box sx={{ width: "100%" }}>
        <Box sx={{ width: "fit-content", maxWidth: "560px" }}>
          {displayReasoning && reasoningComp && reasoningComp}
        </Box>

        <ChatRcvBotDescription>
          <div style={{ whiteSpace: "pre-wrap" }}>{children}</div>
        </ChatRcvBotDescription>
      </Box>
    </ChatRcvBotWidgetWrapper>
  );
};
